import React, { useEffect, useState } from 'react';

import customerDetails from '../../lib/ssp/customerDetails';
import withWaitForCredentials, {
  WithWaitForCredentialsProps,
} from '../../lib/ssp/hocs/WithWaitForCredentials';
import useOrders from '../../lib/ssp/hooks/useOrders';
import { handleLogout } from '../../lib/ssp/utils/handleLogout';
import { getSspLoginPath } from '../../lib/ssp/utils/routesUtil';
import { WithHelpCenterChromeOwnProps } from '../WithHelpCenterChrome';

import OrdersPage from './OrdersPage';

export type WiredOrdersPageProps = WithHelpCenterChromeOwnProps;

type WrappedOrderPageProps = WiredOrdersPageProps & WithWaitForCredentialsProps;

const WiredOrdersPage: React.FC<WrappedOrderPageProps> = ({
  isWaitingForCredentials,
  ...props
}) => {
  const [customerData] = useState(() => customerDetails.getCustomerDetails());
  const {
    data,
    isLoading,
    isError: isFetchError,
    remove,
  } = useOrders(isWaitingForCredentials);

  useEffect(() => {
    remove();
  }, [remove]);

  return (
    <OrdersPage
      {...props}
      // @ts-expect-error data can be undefined
      orders={data}
      isFetchError={isFetchError}
      isLoading={isLoading || isWaitingForCredentials}
      targetOrderName={customerData.orderNumber}
      onLogout={handleLogout}
    />
  );
};

export default withWaitForCredentials<WiredOrdersPageProps>(
  WiredOrdersPage,
  true,
  getSspLoginPath(),
);
